import type { Environment } from '../plugins/aemData';

export function getAssetUrl(asset: string, env: Environment) {
  return `${getAssetsBaseUrl(env)}${asset}`;
}

export function getAssetsBaseUrl(env: Environment) {
  return `https://${env === 'PROD' ? '' : 'int.'}assets.oneweb.mercedes-benz.com/plugin/owpi-owpi-assets/latest/`;
}
